import React from 'react';
import { useParams } from 'react-router-dom';
export function DealDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  return <div data-id="element-1594">
      <div className="flex justify-between items-center mb-6" data-id="element-1595">
        <h1 className="text-2xl font-bold" data-id="element-1596">Deal Details</h1>
        <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-1597">
          Edit
        </button>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1598">
        <div className="lg:col-span-2" data-id="element-1599">
          <div className="bg-white rounded-lg shadow p-6" data-id="element-1600">
            <h2 className="text-lg font-medium mb-4" data-id="element-1601">Deal Information</h2>
            <div className="grid grid-cols-2 gap-4" data-id="element-1602">
              <div data-id="element-1603">
                <p className="text-sm text-neutral-500" data-id="element-1604">Deal Name</p>
                <p className="font-medium" data-id="element-1605">Auto Insurance</p>
              </div>
              <div data-id="element-1606">
                <p className="text-sm text-neutral-500" data-id="element-1607">Client</p>
                <p className="font-medium" data-id="element-1608">John Doe</p>
              </div>
              <div data-id="element-1609">
                <p className="text-sm text-neutral-500" data-id="element-1610">Value</p>
                <p className="font-medium" data-id="element-1611">$1,200</p>
              </div>
              <div data-id="element-1612">
                <p className="text-sm text-neutral-500" data-id="element-1613">Status</p>
                <p className="font-medium" data-id="element-1614">New</p>
              </div>
              <div data-id="element-1615">
                <p className="text-sm text-neutral-500" data-id="element-1616">Created Date</p>
                <p className="font-medium" data-id="element-1617">Jan 15, 2023</p>
              </div>
              <div data-id="element-1618">
                <p className="text-sm text-neutral-500" data-id="element-1619">Expected Close Date</p>
                <p className="font-medium" data-id="element-1620">Feb 28, 2023</p>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-1" data-id="element-1621">
          <div className="bg-white rounded-lg shadow p-6" data-id="element-1622">
            <h2 className="text-lg font-medium mb-4" data-id="element-1623">Deal Progress</h2>
            <div className="space-y-3" data-id="element-1624">
              <div data-id="element-1625">
                <p className="text-sm text-neutral-500" data-id="element-1626">Current Stage</p>
                <p className="font-medium" data-id="element-1627">New</p>
              </div>
              <div data-id="element-1628">
                <p className="text-sm text-neutral-500" data-id="element-1629">Probability</p>
                <p className="font-medium" data-id="element-1630">25%</p>
                <div className="w-full bg-neutral-200 rounded-full h-2.5 mt-2" data-id="element-1631">
                  <div className="bg-blue-600 h-2.5 rounded-full w-1/4" data-id="element-1632"></div>
                </div>
              </div>
              <div data-id="element-1633">
                <p className="text-sm text-neutral-500" data-id="element-1634">Next Action</p>
                <p className="font-medium" data-id="element-1635">Initial Call</p>
              </div>
              <div data-id="element-1636">
                <p className="text-sm text-neutral-500" data-id="element-1637">Next Action Date</p>
                <p className="font-medium" data-id="element-1638">Jan 20, 2023</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}